export class StringUtils {
    static validateUrl(toTest: string) {
        try {
            const url = new URL(toTest)
            return url.protocol === "http:" || url.protocol === "https:"
        } catch (_) {
            return false
        }
    }

    static stringifyJSON<V>(value: V) {
        return JSON.stringify(value, null, 2)
    }

    static parseJSON<O = object>(value?: unknown): undefined | O {
        let returnValue = undefined

        if (value && typeof value === "string") {
            try {
                returnValue = JSON.parse(value)
            } catch {}
        }
        return returnValue
    }

    static stringOrEmpty<V>(val: V) {
        // If val is null or undefined - turn to empty string
        return String(val ?? "")
    }

    static parseWarningsFromErrors(...props: unknown[]) {
        const errorMessages: string[] = []

        for (const prop of props) {
            if (prop instanceof Error) {
                errorMessages.push(prop.message)
            } else if (typeof prop === "string") {
                errorMessages.push(prop)
            }
        }

        return errorMessages
    }
}
